module.exports = __webpack_public_path__ + "static/media/paanteon-process.60d7294f.png";